/**
 * Во что обойдётся откат (§8: «9 из них уже перезаписаны позже»).
 *
 * Серверной оценки нет, но она считается по опубликованному срезу, который уже
 * лежит в сторе: если в данных сейчас не то значение, которое поставил пакет,
 * значит поверх него прошла чужая правка, и откат вернёт старое поверх нового.
 * Эту цифру человек обязан увидеть до нажатия — иначе откат выглядит безобидным.
 */
import type { Brand, Change, ChangeSetDetail } from '@shared/types.ts'

/** Опубликованное сейчас значение той же ячейки, которую трогала правка. */
function publishedValue(brand: Brand, change: Change): { known: boolean; value: unknown } {
  const code = change.key.channelCode
  if (!code || !change.fieldCode) return { known: false, value: undefined }
  const channel = brand.channels[code]
  if (!channel) return { known: false, value: undefined }
  const values: Record<string, unknown> = { ...channel }
  if (!(change.fieldCode in values)) return { known: false, value: undefined }
  return { known: true, value: values[change.fieldCode] }
}

/** Сколько правок пакета уже перезаписаны более поздними. */
export function countOverwritten(detail: ChangeSetDetail, brandsById: Map<number, Brand>): number {
  let count = 0
  for (const change of detail.changes) {
    if (change.action !== 'update' || change.brandId == null) continue
    const brand = brandsById.get(change.brandId)
    if (!brand) continue
    const current = publishedValue(brand, change)
    if (!current.known) continue
    if (JSON.stringify(current.value) !== JSON.stringify(change.newValue)) count += 1
  }
  return count
}
